export const multipleResultInitialState = {
    items: [],
    loading: false
};

const formatterFuncDefault = (entities)=>{
    return entities;
}
export function multipleResultReducer(state = multipleResultInitialState, ACTION, action, formatter=formatterFuncDefault) {
    switch (action.type) {
        case ACTION.REQUEST:

            return {
                ...multipleResultInitialState,
                loading: true
            }

        case ACTION.SUCCESS:
            return {
                ...state,
                items: formatter(action.payload),
                loading: false
            };
        case ACTION.FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }

}



// WEBPACK FOOTER //
// ./src/js/reducers/common/multiple-results.js